import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from "react";
import CheckboxComponent from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { CsValueController, useCsAttribute, useSingleOptionBoolValue, useSingleOptionBoolValueSelection, } from "@plansoft-configuration-renderer/framework";
import { useAttributeInlineLabel } from "../../Attributes/useAttributeInlineLabel";
import { useAttributeLayout } from "../../layouts/AttributeLayoutContext";
import { SingleOptionBoolNotice } from "./SingleOptionBoolNotice";
export function SingleOptionCheckbox(props) {
    const { showIndeterminate = true, children } = props;
    const { singleValue } = useSingleOptionBoolValue();
    const { formLabel } = useAttributeInlineLabel();
    const { fullWidth } = useAttributeLayout();
    return (_jsxs(Fragment, { children: [_jsxs(FormControl, { component: "fieldset", fullWidth: fullWidth, children: [formLabel, _jsx(FormGroup, { children: singleValue && (_jsx(CsValueController, { value: singleValue, children: _jsx(SingleCheckboxOption, { showIndeterminate: showIndeterminate, children: children }) })) })] }), _jsx(SingleOptionBoolNotice, {})] }));
}
function SingleCheckboxOption(props) {
    const attribute = useCsAttribute();
    const checkboxId = `single-checkbox-${attribute.id}`;
    const { showIndeterminate } = props;
    const { toggleSingle, isIndeterminate, isDisabled, isSelected } = useSingleOptionBoolValueSelection({ showIndeterminate });
    return (_jsx(FormControlLabel, { id: checkboxId, checked: isSelected, disabled: isDisabled, onChange: toggleSingle, control: _jsx(CheckboxComponent, { disabled: isDisabled, indeterminate: isIndeterminate }), label: _jsx(_Fragment, { children: props.children }), disableTypography: true, sx: { width: "100%" } }));
}
//# sourceMappingURL=SingleOptionCheckbox.js.map